// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1DatabaseType } from './V1DatabaseType';
import {
  V1DatabaseTypeFromJSON,
  V1DatabaseTypeFromJSONTyped,
  V1DatabaseTypeToJSON,
  V1DatabaseTypeToJSONTyped,
} from './V1DatabaseType';
import type { V1DatabaseConfig } from './V1DatabaseConfig';
import {
  V1DatabaseConfigFromJSON,
  V1DatabaseConfigFromJSONTyped,
  V1DatabaseConfigToJSON,
  V1DatabaseConfigToJSONTyped,
} from './V1DatabaseConfig';

/**
 *
 * @export
 * @interface V1DatabasesReconcilerDatabaseSpec
 */
export interface V1DatabasesReconcilerDatabaseSpec {
  /**
   *
   * @type {V1DatabaseConfig}
   * @memberof V1DatabasesReconcilerDatabaseSpec
   */
  config?: V1DatabaseConfig;
  /**
   *
   * @type {string}
   * @memberof V1DatabasesReconcilerDatabaseSpec
   */
  id?: string;
  /**
   *
   * @type {number}
   * @memberof V1DatabasesReconcilerDatabaseSpec
   */
  incarnation?: number;
  /**
   *
   * @type {string}
   * @memberof V1DatabasesReconcilerDatabaseSpec
   */
  name?: string;
  /**
   *
   * @type {V1DatabaseType}
   * @memberof V1DatabasesReconcilerDatabaseSpec
   */
  type?: V1DatabaseType;
}

/**
 * Check if a given object implements the V1DatabasesReconcilerDatabaseSpec interface.
 */
export function instanceOfV1DatabasesReconcilerDatabaseSpec(
  value: object,
): value is V1DatabasesReconcilerDatabaseSpec {
  return true;
}

export function V1DatabasesReconcilerDatabaseSpecFromJSON(
  json: any,
): V1DatabasesReconcilerDatabaseSpec {
  return V1DatabasesReconcilerDatabaseSpecFromJSONTyped(json, false);
}

export function V1DatabasesReconcilerDatabaseSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1DatabasesReconcilerDatabaseSpec {
  if (json == null) {
    return json;
  }
  return {
    config:
      json['config'] == null
        ? undefined
        : V1DatabaseConfigFromJSON(json['config']),
    id: json['id'] == null ? undefined : json['id'],
    incarnation: json['incarnation'] == null ? undefined : json['incarnation'],
    name: json['name'] == null ? undefined : json['name'],
    type:
      json['type'] == null ? undefined : V1DatabaseTypeFromJSON(json['type']),
  };
}

export function V1DatabasesReconcilerDatabaseSpecToJSON(
  json: any,
): V1DatabasesReconcilerDatabaseSpec {
  return V1DatabasesReconcilerDatabaseSpecToJSONTyped(json, false);
}

export function V1DatabasesReconcilerDatabaseSpecToJSONTyped(
  value?: V1DatabasesReconcilerDatabaseSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    config: V1DatabaseConfigToJSON(value['config']),
    id: value['id'],
    incarnation: value['incarnation'],
    name: value['name'],
    type: V1DatabaseTypeToJSON(value['type']),
  };
}
